import Scroll from '@/utils/AbstractScroll'
import Debounce from '@/utils/Debounce.js';
import Store from '@/stores/store.js'
import Bus from '@/bus/BusEvent.js'

export default class ThreeScroll {
    constructor(container, offsets, name = '') {
        //INITIALIZE VAR
        this.scroll = null
        this.sizes = {};
        this.container = container

        this.name = name

        //RETREIVE OUR OFFSET
        this.offsets = offsets

        //USE A PARENT GROUP TO KEEP CHILD POSITIONING
        this.anchor = new THREE.Object3D();
        this.anchor.position.x = 0
        this.anchor.position.y = 0
        this.anchor.add(this.container);

        //DEBOUNCE THE RESIZE EVENT TO PREVENT UNECESSARY WORK
        this.resizeSmoothDebounced = Debounce(this._resize, 500);

        this.init()
        this.events()
    }

    init() {
        //COMPUTED THE SCROLLABLE HEIGHT
        this.distance = this.getBoundingHeight()
        //INIT THE ABSTRACT SCROLL
        this.scroll = new Scroll({
            x: 0,
            y: this.distance + this.offsets.top + this.offsets.bottom
        }, 1, window, this.scrollHandler.bind(this), this.container, this.name)
    }
    
    _resize() {
        this.update()
    }

    disable() {
        this.scroll.disable()
    }

    enable() {
        this.scroll.enable()
        let box = new THREE.Box3().setFromObject(this.container);
        Store.scrollHeight = box.getSize(new THREE.Vector3()).y 
    }

    scrollHandler(x, y) {
        this.anchor.position.y = -y
    }

    getBoundingHeight() {
        let box = new THREE.Box3().setFromObject(this.container);
        return box.getSize(new THREE.Vector3()).y - Store.height
    }

    updateOffset(params) {
        this.offsets = params
        this.update()
    }


    resetScroll() {
        this.scroll.reset()
    }

    update() {
        this.distance = this.getBoundingHeight()
        this.scroll.resize({
            x: 0,
            y: this.distance + this.offsets.top + this.offsets.bottom
        })
    }

    events() {
        Bus.$on('resize', () => {
            this.resizeSmoothDebounced();
        });

        Bus.$on('updateScroll', () => {
            this.update();
        });
    }
}